export default "__VITE_ASSET__Dy_dreOE__"